module.exports = __webpack_public_path__ + "img/login.6d9efcf6.png";